/* eslint-disable */

const passwordActionTypes = {
    RECOVERY_PASSWORD_START: "RECOVERY_PASSWORD_START",
    RECOVERY_PASSWORD_SUCCESS: "RECOVERY_PASSWORD_SUCCESS",
    RECOVERY_PASSWORD_FAILURE: "RECOVERY_PASSWORD_FAILURE",
    SEND_MESSAGE_START: "SEND_MESSAGE_START",
    SEND_MESSAGE_SUCCESS: "SEND_MESSAGE_SUCCESS",
    SEND_MESSAGE_FAILURE: "SEND_MESSAGE_FAILURE",
    UPDATE_PAGE: "UPDATE_PAGE",
};

export default passwordActionTypes;
